"use client";

import { ContentView } from "./components/ContentView";
import { Navigation } from "./components/Navigation";
import { Sidebar } from "./components/Sidebar";
import { Toolbar } from "./components/Toolbar";
import { useFileExplorer } from "./hooks/useFileExplorer";

const FileExplorer = () => {
    const {
        viewMode,
        setViewMode,
        currentPath,
        searchQuery,
        setSearchQuery,
        filteredContent,
        navigateToFolder,
        navigateUp,
        navigateToPathSegment,
        selectedItems,
        toggleItemSelection,
        currentNode,
        getSidebarNodes,
    } = useFileExplorer();

    const sidebarNodes = getSidebarNodes();

    return (
        <div className="w-full h-full flex flex-col bg-gray-100">
            <Toolbar viewMode={viewMode} onViewModeChange={setViewMode} />
            <Navigation
                currentPath={currentPath}
                onNavigateUp={navigateUp}
                onNavigateToPathSegment={navigateToPathSegment}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
            />
            <div className="flex-1 flex overflow-hidden">
                <Sidebar nodes={sidebarNodes} onNavigateToKnownLocation={navigateToFolder} />
                <div className="flex-1 overflow-y-auto p-2">
                    <ContentView
                        viewMode={viewMode}
                        items={currentNode?.children || filteredContent}
                        onNavigateToFolder={navigateToFolder}
                        selectedItems={selectedItems}
                        onToggleItemSelection={toggleItemSelection}
                    />
                </div>
            </div>
        </div>
    );
};

export default FileExplorer;
